<template>
  <div>
    <div class="card center" style="width: 90%; top: -50px; text-align: center">
      <div class="card-body">
        <div>
          <button
            type="button"
            class="branch-picker-trigger"
            :class="
              data.branchId === '' || data.selectedServiceCategoryId === ''
                ? 'service-category-item-unselected'
                : 'service-category-item-selected'
            "
            v-on:click="handleBranchPickerClick()"
          >
            <span>{{ getBranchDisplayText() }}</span>
            <span class="branch-picker-arrow">▾</span>
          </button>
        </div>
        <div v-if="getNow() !== 2 && data.isOpen">
          <h5 class="current_number">目前號碼 ｜Current Number</h5>
          <div class="spinner-border text-primary" style="
              color: #154080 !important;
              margin-top: 55px;
              margin-bottom: 55px;
              width: 3rem;
              height: 3rem;
            " role="status" v-if="!data.dataLoad">
            <span class="sr-only"></span>
          </div>
          <p class="number" v-if="data.dataLoad">
            {{ data.currentNumber }}
          </p>
          <p class="waiting_time">
            <img src="@/assets/alarm.svg" width="24" class="mx-1 pb-1" />
            {{ convertTimeToRange(Math.ceil(data.waitingTime)) }}
            <span style="font-size: 20px" class="mx-1">min</span>
          </p>
        </div>
        <div v-if="getNow() === 2 || !data.isOpen">
          <h5 class="current_number">目前號碼 ｜Current Number</h5>
          <p class="number">0</p>
          <p class="waiting_time">非營業時間</p>
        </div>
        <h5 class="designer_list_title">指定理髮師 ｜Assigned barber</h5>
        <p
          class="designer_hint"
          v-if="data.selectedServiceCategoryId === '' || data.branchId === ''"
        >
          請先選擇服務類型與分店
        </p>
        <div
          class="row row-cols-2 row-cols-md-2 g-2"
          v-if="data.selectedServiceCategoryId !== '' && data.branchId !== ''"
        >
          <div class="col" v-for="(d, index) in data.designers" :key="index">
            <div class="designer_block">
              <!-- set img fit conver and width and height same -->
              <img :src="d.photo" :class="!d.isSelect ? `disable_designer` : ''" v-on:click="changeDesiger(d.id)"
                style="padding: 4px; width: 100%; object-fit: cover"
                v-if="d.id != undefined && d.id != '' && d.photo != ''" />
              <!-- set this img weight and height same d.photo -->
              <img src="@/assets/solid.png" :class="!d.isSelect ? `disable_designer` : ''"
                v-on:click="changeDesiger(d.id)" style="padding: 4px; width: 100%; object-fit: contain"
                v-if="d.id == '' || d.id == undefined || d.photo == ''" />
              <p class="designer_name">{{ d.designer }}</p>
            </div>
          </div>
        </div>
        <div class="d-grid gap-2" style="margin-top: 2rem">
          <button
            class="btn btn-lg btn-primary btn-primary-custom"
            type="button"
            v-on:click="checkStatus()"
          >
            會員取票
          </button>
        </div>
      </div>
    </div>
    <div v-if="data.showServiceCategoryModal" class="service-category-modal-backdrop" v-on:click.self="closeServiceCategoryModal()">
      <div class="service-category-modal card">
        <div class="card-body">
          <h5 class="service-category-modal-title">請先選擇服務類型</h5>
          <div v-if="data.categoryLoading" class="spinner-border text-primary" role="status">
            <span class="sr-only"></span>
          </div>
          <div v-else>
            <button
              v-for="(item, index) in data.serviceCategories"
              :key="index"
              type="button"
              class="service-category-item"
              :class="data.selectedServiceCategoryId === item.id ? 'service-category-item-selected' : 'service-category-item-unselected'"
              v-on:click="selectServiceCategory(item.id)"
            >
              {{ item.title }}
            </button>
          </div>
          <div class="service-category-modal-actions">
            <button class="btn btn-lg btn-secondary-custom modal-cancel-btn" type="button" v-on:click="closeServiceCategoryModal()">取&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;消</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="data.showBranchModal" class="service-category-modal-backdrop" v-on:click.self="closeBranchModal()">
      <div class="service-category-modal card">
        <div class="card-body">
          <h5 class="service-category-modal-title">請選擇分店</h5>
          <div v-if="data.branchLoading" class="spinner-border text-primary" role="status">
            <span class="sr-only"></span>
          </div>
          <div v-else>
            <button
              v-for="(item, index) in data.branchs"
              :key="index"
              type="button"
              class="service-category-item"
              :class="data.branchId === item.id ? 'service-category-item-selected' : 'service-category-item-unselected'"
              v-on:click="selectBranch(item.id)"
            >
              {{ item.branch }}
            </button>
          </div>
          <div class="service-category-modal-actions">
            <button class="btn btn-lg btn-secondary-custom modal-cancel-btn" type="button" v-on:click="closeBranchModal()">取&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;消</button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="data.categoryLoading || data.branchLoading || data.designersLoading"
      class="page-loading-overlay"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
    <vue3-confirm-dialog-box></vue3-confirm-dialog-box>
  </div>
</template>

<script>
import { onMounted, reactive, computed } from "@vue/runtime-core";
import axios from "axios";
import { useStore } from "vuex";
import "vue3-toastify/dist/index.css";

export default {
  name: "HelloWorld",
  components: {},
  props: {
    msg: String,
  },
  setup() {
    const data = reactive({
      designers: [],
      currentNumber: 0,
      waitingClient: 0,
      selectId: "",
      waitingTime: 0,
      openHour: "",
      closeHour: "",
      alertHour: "",
      isAlertHour: "",
      dataLoad: false,
      branchs: [],
      branchId: "",
      isOpen: true,
      branchList: [],
      serviceCategories: [],
      selectedServiceCategoryId: "",
      showServiceCategoryModal: false,
      categoryLoading: false,
      showBranchModal: false,
      branchLoading: false,
      designersLoading: false,
    });
    onMounted(() => {
      data.categoryLoading = true;
      axios
        .get(`${process.env.VUE_APP_URL}/service/serviceCategories`)
        .then((res) => {
          const categories = (res.data.data || [])
            .filter((item) => item.status === 1)
            .sort((a, b) => a.sort - b.sort)
            .map((item) => ({
              id: item._id,
              title: item.title,
            }));
          data.serviceCategories = categories;
        })
        .finally(() => {
          data.categoryLoading = false;
        });

      data.branchId = "";
      data.dataLoad = true;
    });

    const store = useStore();
    const states = reactive({
      username: computed(() => store.state.auth.user.username),
      isAuthenticated: computed(() => store.getters["auth/isAuthenticated"]),
    });
    return {
      states,
      //handleSetProfile,
      data,
    };
  },
  mounted() {
    // if (this.$store.state.auth.token == null) {
    //   this.$router.push(`/signIn`);
    // }
  },
  methods: {
    handleBranchPickerClick() {
      this.openServiceCategoryModal();
    },
    openServiceCategoryModal() {
      this.closeBranchModal();
      this.data.selectedServiceCategoryId = "";
      this.data.branchId = "";
      this.data.branchs = [];
      this.data.showServiceCategoryModal = true;
    },
    closeServiceCategoryModal() {
      this.data.showServiceCategoryModal = false;
    },
    selectServiceCategory(id) {
      this.data.selectedServiceCategoryId = id;
      this.data.branchId = "";
      this.data.branchs = [];
      this.data.showServiceCategoryModal = false;
      this.data.branchLoading = true;
      axios
        .get(`${process.env.VUE_APP_URL}/service/branchsByCategoryId`, {
          params: {
            categoryId: this.data.selectedServiceCategoryId,
          },
        })
        .then((res) => {
          const branches = (res.data.data || []).map((item) => ({
            id: item.id == undefined ? item._id : item.id,
            branch: item.title,
          }));
          this.data.branchs = branches;
          this.data.branchList = branches;
          this.data.branchId = "";
          this.openBranchModal();
        })
        .finally(() => {
          this.data.branchLoading = false;
        });
    },
    openBranchModal() {
      this.data.showBranchModal = true;
    },
    closeBranchModal() {
      this.data.showBranchModal = false;
    },
    selectBranch(id) {
      if (id == undefined || id === "") {
        return;
      }
      // set open hour and close hour 
      axios
        .get(`${process.env.VUE_APP_URL}/service/branchs`, {
        })
        .then((res) => {
          const branchList = res.data.data;
          for (let i = 0; i < branchList.length; ++i) {
            if (branchList[i].id == id) {
              console.log("getNow", branchList[i]);
              this.data.openHour = branchList[i].openingHours.open;
              this.data.closeHour = branchList[i].openingHours.close;
              this.data.isOpen = branchList[i].isOpen;
              break;
            }
          }
        })
        .finally(() => {
          this.data.branchId = id;
          this.closeBranchModal();
          this.getDesignersByBranchId();
        });
    },
    getBranchDisplayText() {
      if (this.data.branchId === "" || this.data.selectedServiceCategoryId === "") {
        return "請選擇服務類型與分店";
      }
      const category = this.data.serviceCategories.find(
        (item) => item.id === this.data.selectedServiceCategoryId
      );
      const branch = this.data.branchs.find((item) => item.id === this.data.branchId);
      if (category == undefined || branch == undefined) {
        return "請選擇服務類型與分店";
      }
      return `${category.title}・${branch.branch}`;
    },
    changeDesiger(id) {
      for (var i = 0; i < this.data.designers.length; ++i) {
        this.data.designers[i].isSelect = false;
      }
      for (var j = 0; j < this.data.designers.length; ++j) {
        if (this.data.designers[j].id === id) {
          this.data.designers[j].isSelect = true;
          this.data.currentNumber = this.data.designers[j].serviceNo;
          this.data.selectId = this.data.designers[j].id;
          this.data.waitingClient = this.data.designers[j].waitingClient;
          this.data.waitingTime = this.data.designers[j].waitingTime;
        }
      }
    },
    checkStatus() {
      this.states;
      if (this.data.selectedServiceCategoryId === "" || this.data.branchId === "") {
        this.$confirm({
          title: "提示",
          message: "請選擇服務類型與分店",
          button: {
            yes: "確認",
          },
          callback: () => {

          },
        });
        return;
      }
      if (this.getNow() === 1) {
        this.$confirm({
          title: "注意",
          message: `如到達現場已超過 ${this.data.alertHour}，則會自動取消您的取號`,
          button: {
            no: "取消",
            yes: "我知道了",
          },
          callback: (confirm) => {
            if (confirm) {
              this.goToReserve();
            }
          },
        });
      } else if (this.getNow() === 2) {
        this.$confirm({
          title: "提示",
          message: "已超過營業時間",
          button: {
            yes: "確認",
          },
          callback: () => {

          },
        });
      } else if (this.data.isOpen == false) {
        this.$confirm({
          title: "提示",
          message: "非營業時間",
          button: {
            yes: "確認",
          },
          callback: () => {

          },
        });
      } else {
        this.goToReserve();
      }
    },
    goToReserve() {
      if (this.states.isAuthenticated === false) {
        this.$router.push({ path: "/signIn" });
      } else {
        this.data.selectId = this.data.selectId == "" ? "n" : this.data.selectId;
        this.$router.push({
          path: `/reserve/${this.data.selectId}`,
          query: {
            branchId: this.data.branchId,
            serviceCategoryId: this.data.selectedServiceCategoryId,
            mainCategoryId: this.data.selectedServiceCategoryId,
          },
        });
      }
    },
    getNow() {
      if (this.data.openHour === "" || this.data.closeHour === "") {
        return 0;
      }
      const today = new Date();
      const date =
        today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      // today.getHours() format 00:00
      const hour = today.getHours() < 10 ? "0" + today.getHours() : today.getHours();

      const minute =
        today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();

      const time = hour + ":" + minute;
      const dateTime = date + " " + time;
      if (
        dateTime >= `${date} ${this.data.closeHour}` ||
        dateTime <= `${date} ${this.data.openHour}`
      ) {
        return 2;
      } else if (dateTime >= `${date} ${this.data.isAlertHour}}`) {
        return 1;
      } else {
        return 0;
      }
    },
    getBusinessHours(open, close, alert) {
      this.data.openHour = open;
      this.data.closeHour = close;
      this.calculatorAlertTime(alert);
    },
    getDesignersByBranchId() {
      if (this.data.branchId === "") {
        return;
      }
      localStorage.setItem("branchId", this.data.branchId);
      this.data.designersLoading = true;

      axios
        .post(`${process.env.VUE_APP_URL}/service/designersByBranchId`, {
          branchId: this.data.branchId,
        })
        .then((res) => {
          this.data.designers = [];
          for (let i = 0; i < res.data.data.length; ++i) {
            this.data.designers.push({
              id:
                res.data.data[i].id == undefined
                  ? res.data.data[i]._id
                  : res.data.data[i].id,
              designer: res.data.data[i].designer,
              photo:
                res.data.data[i].photo == ""
                  ? ""
                  : `${process.env.VUE_APP_AWS_S3_URL}/${res.data.data[i].photo}`,
              isSelect: i == 0,
              serviceNo: res.data.data[i].serviceNo,
              waitingClient: res.data.data[i].waitingClient,
              waitingTime: res.data.data[i].waitingTime,
            });
            if (i === 0) {
              this.data.selectId = res.data.data[i].id;
              this.data.currentNumber = res.data.data[i].serviceNo;
              this.data.designers[0].isSelect = true;
              this.data.waitingClient = res.data.data[0].waitingClient;
              this.data.waitingTime = res.data.data[0].waitingTime;
            }
          }
          this.data.dataLoad = true;
        })
        .finally(() => {
          this.data.designersLoading = false;
        });
    },
    calculatorAlertTime(inputTimeString) {
      let inputTimeArray = inputTimeString.split(":");
      let inputTime = new Date();
      inputTime.setHours(parseInt(inputTimeArray[0], 10));
      inputTime.setMinutes(parseInt(inputTimeArray[1], 10));

      // 將時間減去半小時
      let halfAnHourAgo = new Date(inputTime.getTime() - 30 * 60 * 1000);
      // 將時間減去10分鐘
      let tenAnHourAgo = new Date(inputTime.getTime() - 10 * 60 * 1000);

      // 格式化為 HH:mm 字串
      let formattedTime = `${halfAnHourAgo.getHours()}:${halfAnHourAgo.getMinutes()}`;
      let tenFormattedTime = `${tenAnHourAgo.getHours()}:${tenAnHourAgo.getMinutes()}`;

      this.data.alertHour = tenFormattedTime;
      this.data.isAlertHour = formattedTime;
    },
    convertTimeToRange(time) {
      if (time == 0) {
        return "0";
      } else if (time > 0 && time <= 10) {
        return "5+";
      } else if (time > 10 && time <= 20) {
        return "10+";
      } else if (time > 20 && time <= 40) {
        return "20+";
      } else if (time > 40 && time <= 60) {
        return "40+";
      } else {
        return "60+";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.header_block {
  position: relative;
  text-align: center;
}

.center {
  margin: auto;
  width: 50%;
  padding: 10px;
  border-radius: 0px;
}

.current_number {
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  align-items: center;
  display: flex;
  color: #1e2939;
  margin-top: 24px;
}

.number {
  margin-top: 36px;
  font-family: "Squada One", cursive;
  font-style: normal;
  font-weight: 400;
  font-size: 128px;
  line-height: 135px;
  align-items: center;
  text-align: center;
  color: #af7f04;
}

.waiting_time {
  margin-top: 30px;
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: #424242;
}

.designer_list_title {
  margin-top: 60px;
  margin-left: 2%;
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 700;
  display: flex;
  font-size: 18px;
  line-height: 24px;
  align-items: center;
  color: #243651;
  margin-bottom: 28px;
}

.designer_block {
  position: relative;
  text-align: center;
}

.designer_name {
  position: absolute;
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 20px;
  line-height: 25px;
  bottom: -5px;
  left: 28px;
  color: #ffffff;
}

.designer_hint {
  font-family: "Noto Sans TC", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #5d5d5d;
  margin: 12px 0 20px 0;
}

.disable_designer {
  opacity: 0.2;
}

.btn-primary-custom {
  box-sizing: border-box;
  height: 60px;
  left: 65px;
  top: 1010px;
  background: #243651;
  border-radius: 8px;
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
}

.side_menu {
  position: absolute;
  left: 15%;
  right: 15%;
  top: 20%;
  bottom: 20%;
}

.logo {
  position: absolute;
  width: 205px;
  height: 65px;
  left: 90px;
  top: 20px;
  z-index: 999;
}

.g-2,
.gx-2 {
  --bs-gutter-x: -0.5rem;
}

.vc-btn.left {
  display: none !important;
}

.service-category-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.service-category-modal {
  width: 100%;
  max-width: 420px;
  border-radius: 12px;
}

.service-category-modal-title {
  font-family: "Noto Sans TC", sans-serif;
  font-weight: 700;
  font-size: 22px;
  color: #243651;
  margin-bottom: 20px;
}

.service-category-item {
  width: 100%;
  text-align: left;
  border-radius: 8px;
  padding: 18px 16px;
  margin-bottom: 10px;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 18px;
  font-weight: 600;
  border: 1px solid #5d5d5d;
  background: #ffffff;
}

.branch-picker-trigger {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 18px 16px;
  margin-bottom: 10px;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 18px;
  font-weight: 600;
  box-shadow: none;
}

.branch-picker-arrow {
  font-size: 16px;
}

.branch-picker-trigger:focus,
.service-category-item:focus {
  box-shadow: none;
}

.service-category-item-selected {
  background: #f6f1e7;
  border: 1px solid #a9790b;
}

.service-category-item-unselected {
  background: #ffffff;
  border: 1px solid #5d5d5d;
}

.service-category-modal-actions {
  display: flex;
  margin-top: 20px;
}

.modal-cancel-btn {
  width: 100%;
}

.btn-secondary-custom {
  background: #cac6c6;
  box-sizing: border-box;
  height: 60px;
  border-radius: 8px;
  font-family: "Noto Sans TC", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 31px;
  color: #ffffff;
}

.page-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: rgba(255, 255, 255, 0.72);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.page-loading-text {
  margin-top: 12px;
  margin-bottom: 0;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #243651;
}
</style>
